import Player from '@vimeo/player';
import {Subject} from "rxjs";
import {ConcatScroll} from "./concat-scroll";
import {debounceTime, filter, tap} from "rxjs/operators";

const cuePointSubject = new Subject();
let player;
let subtitleElems;

export const init = (titlesSelector,
                                concatScroll: ConcatScroll) => {


    const iframe = document.querySelector('iframe');

    subtitleElems = $(titlesSelector);
    console.log('ELEMS', subtitleElems);
    const times = [];
    subtitleElems.each( (index, el) => {
        console.log(el);
        times.push( $(el).attr('data-time'));
    });
    console.log('TIMES', times);


    player = new Player(iframe);
    /*player.on('bufferstart', () => {
        console.log('VIMEO, buffstart');
    });
    player.on('progress', (p) => {
        console.log('VIMEO, progress', p);
    });*/

    /*if( data.cuePoints ) {
        data.cuePoints.forEach( (cuePoint, index) => {

        } )
    }*/
    times.forEach((val, index) => {
        player.addCuePoint(val,{
            //text: cuePoint.text,
            index: index
        });
    });

    let first = true;

    player.on('cuepoint', (cuePoint) => {
        //console.log('VIMEO, CUEPOINT', cuePoint);
        // cuePointSubject.next(cuePoint.data.index);
        const el = subtitleElems[cuePoint.data.index];
        const prev = (cuePoint.data.index - 1 + subtitleElems.length) % subtitleElems.length;
        const elPrev = subtitleElems[prev];
        //console.log(el);
        //$(el).removeClass('hide1 hide2');
        $(el).removeClass('hide initial');
        $(el).addClass('show');
        if( !first){
            $(elPrev).addClass('hide');
            $(elPrev).removeClass('show');
        }
        first = false;
    });

    concatScroll.scrollStart$.pipe(
       filter( e => e.startY >= -100 && e.startY < 100),
       tap( _=> pausePlayer() )
    ).subscribe();

    concatScroll.scrollStop$.pipe(
       filter( e => e['endY'] >= -100 && e['endY'] < 100),
       debounceTime(50),
       tap(_ => resumePlayer())
    ).subscribe()
};

export const pausePlayer = () => {
    console.log('pause player??', player);
    if(player){
        player.pause();
        subtitleElems.each((index, el) =>{
            $(el).addClass('initial');
        })
    }
};

export const resumePlayer = () => {
    if(player) {
        player.play();
    }
}

export const cuePoints$ = cuePointSubject.asObservable();